import React from "react";
import useReveal from "../hooks/useReveal";

export const Kicker = ({ children, testId }) => (
  <span className="inline-flex items-center gap-2 text-narwhal-teal text-xs font-semibold tracking-[0.2em] uppercase" data-testid={testId}>
    <span className="w-6 h-px bg-narwhal-teal/60" />
    {children}
  </span>
);

export const SectionHeading = ({ kicker, title, accent, body, center = false, className = "", testId }) => {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal ${center ? "text-center mx-auto" : ""} max-w-3xl ${className}`} data-testid={testId ? `${testId}-heading-content` : undefined}>
      {kicker && <Kicker testId={testId ? `${testId}-kicker` : undefined}>{kicker}</Kicker>}
      <h2 className="mt-5 text-3xl md:text-5xl font-light text-white leading-[1.08] tracking-tight text-balance" data-testid={testId ? `${testId}-title` : undefined}>
        {title} {accent && <span className="text-narwhal-teal font-medium" data-testid={testId ? `${testId}-title-accent` : undefined}>{accent}</span>}
      </h2>
      {body && <p className="mt-6 text-narwhal-muted text-base md:text-lg leading-relaxed" data-testid={testId ? `${testId}-description` : undefined}>{body}</p>}
    </div>
  );
};

export default SectionHeading;
